package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.date_picker.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.width
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.DayModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel

@Composable
fun CalendarDayNumbers(
    currentMonth: MonthModel,
    onDayClick: (MonthModel) -> Unit,
    selectedDay: MonthModel?,
) {
    Column(
        modifier = Modifier
            .width(Dimen.DateDaysWidth),
    ) {

        val adjustedDays = adjustDaysToStartFromMonday(currentMonth.days)

        adjustedDays.chunked(7).forEachIndexed { index, week ->
            Row {
                week.forEach { day ->
                    DateNumberItem(
                        number = day.dayNumber,
                        selectedDate = selectedDay,
                        currentMonth = currentMonth.monthName,
                        currentYear = currentMonth.yearNumber,
                        monthNumber = currentMonth.monthNumber,
                        isCurrentMonthDay = day.isCurrentMonth,
                        onSelectNumber = {
                            onDayClick(it)
                        },
                    )
                }
            }
        }
    }
}

private fun adjustDaysToStartFromMonday(days: List<DayModel>): List<DayModel> {
    val firstDay = days.first()

    val dayOfWeek = when (firstDay.dayName) {
        "Monday" -> 0
        "Tuesday" -> 1
        "Wednesday" -> 2
        "Thursday" -> 3
        "Friday" -> 4
        "Saturday" -> 5
        "Sunday" -> 6
        else -> 0
    }

    val previousMonthDays = calculatePreviousMonthDays(dayOfWeek)

    val currentMonthDays = days.map { day ->
        DayModel(
            dayNumber = day.dayNumber,
            dayName = day.dayName,
            isCurrentMonth = true
        )
    }

    return previousMonthDays + currentMonthDays + calculateNextMonthDays(days.size, dayOfWeek)
}

private fun calculatePreviousMonthDays(dayOfWeek: Int): List<DayModel> {
    if (dayOfWeek == 0) return emptyList()
    val daysInPreviousMonth = when (getCurrentMonth() - 1) {
        0 -> getDaysInMonth(12, getCurrentYear() - 1)
        2 -> if (isLeapYear(getCurrentYear())) 29 else 28
        4, 6, 9, 11 -> 30
        else -> 31
    }

    return List(dayOfWeek) { index ->
        val dayNumber = daysInPreviousMonth - dayOfWeek + index + 1
        DayModel(
            dayNumber = dayNumber,
            dayName = "",
            isCurrentMonth = false
        )
    }
}

private fun calculateNextMonthDays(currentMonthDaysCount: Int, dayOfWeek: Int): List<DayModel> {

    val totalDaysInCalendar = 42
    val daysNeededFromNextMonth =
        totalDaysInCalendar - currentMonthDaysCount - dayOfWeek

    return List(daysNeededFromNextMonth) { index ->
        DayModel(
            dayNumber = index + 1,
            dayName = "",
            isCurrentMonth = false
        )
    }
}

private fun getCurrentMonth(): Int {
    val now = kotlinx.datetime.Clock.System.now()
    return now.toLocalDateTime(kotlinx.datetime.TimeZone.currentSystemDefault()).month.number
}

private fun getCurrentYear(): Int {
    val now = kotlinx.datetime.Clock.System.now()
    return now.toLocalDateTime(kotlinx.datetime.TimeZone.currentSystemDefault()).year
}

private fun getDaysInMonth(month: Int, year: Int): Int {
    return when (month) {
        2 -> if (isLeapYear(year)) 29 else 28
        4, 6, 9, 11 -> 30
        else -> 31
    }
}

private fun isLeapYear(year: Int): Boolean {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)
}